<div *ngIf="displaypopup" class="modal modal-cls" tabindex="-1" role="dialog" [ngStyle]="{'display':displaypopup}">
  <div class="modal-dialog" role="document ">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Changed Columns</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closemodel('cencel')">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row" *ngIf="popupcontents">

            <div  *ngFor="let d of popupcontents" class="col-4 m-2 text-center" >

              <p style="border-bottom: 1px solid red;"> {{d}}</p>

            </div>



        </div>
        <p  *ngIf="!nullmessage">Are you Sure you want to make  changes </p>
        <div *ngIf="nullmessage">
         <p class="text-danger">{{nullmessage}}</p>


      </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="closemodel('save')">Save changes</button>
        <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="closemodel('cancel')">Close</button>
      </div>
    </div>
  </div>
</div>
